import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { AudioLines, Globe, ListChecks, Settings } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'

export const Playground = () => {
  return (
    <>
      <Header title="Playground" subTitle="Experimental" />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.PLAYGROUND_COACH_SKILLS_COLLECTION}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <AudioLines size={14} />
                  <Text fontSize={2} color="lightText">
                    Coach Skills Collection
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Start a Coach Skills Collection call with the AI voice agent.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.PLAYGROUND_COACH_ASSESSMENTS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <AudioLines size={14} />
                  <Text fontSize={2} color="lightText">
                    Coach Assessments
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Start a Coach Assessments call with the AI voice agent. Requires
                a shift ID.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.PLAYGROUND_HIGHNOTE_NOTIFICATION_TASKS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <ListChecks size={14} />
                  <Text fontSize={2} color="lightText">
                    Highnote Notification Tasks
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Inspect failed Highnote webhook events and retry processing.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.PLAYGROUND_HTTP_SERVICES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <Globe size={14} />
                  <Text fontSize={2} color="lightText">
                    Temu Postman
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Run GET requests against services for development purposes.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.HIGHNOTE_TOPUP}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <Settings size={14} />
                  <Text fontSize={2} color="lightText">
                    Highnote Topup Config
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                View and update Highnote topup configuration variables
                (thresholds, forecast buffer, lookahead days).
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
